import React from 'react';
import { NikoFacilityOrderUSIntakeFindAndReplaceModalTemplate} from 'themes/application/niko-facility-order-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderUSIntakeFindAndReplaceModalStore } from 'application/niko-facility-order-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderUSIntakeFindAndReplaceModalStore(rootStore, componentProps), 'nikoFacilityOrderUSIntakeFindAndReplaceModalStore')
@observer
class NikoFacilityOrderUSIntakeFindAndReplaceModal extends React.Component {
    render() {
        return <NikoFacilityOrderUSIntakeFindAndReplaceModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderUSIntakeFindAndReplaceModal;
